import type { RowBoxProps } from './types'

import * as S from './styles'

export const RowBox = ({ children, columns = 1, gap = 16, marginTop, marginBottom, ...rest }: RowBoxProps) => {
  return (
    <S.Container columns={columns} gap={gap} marginTop={marginTop} marginBottom={marginBottom} {...rest}>
      {children}
    </S.Container>
  )
}
